// extracted by mini-css-extract-plugin
module.exports = {"ErrorIndicator":"ErrorIndicator__ErrorIndicator___3_gdS","error":"ErrorIndicator__error___1u2iK"};